import { apiPlugin, ApiPluginOptions, TitleMixin } from "@/shared";
import { RegisterGlobalComponents } from "@/shared/components";
import { RegisterGlobalFilters } from "@/shared/filters";
import { RegisterGlobalUtils } from "@/shared/utils";
import ElementPlus from "element-plus";
import { createApp } from "vue";
import App from "./App.vue";
/**
 * Layout and global components
 */
import { AppMainLayout, LeftNavComponent, TopNavComponent } from "./components";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
// collapse
/**
 * Create the main app and attach the needed plugins and modules
 */
const app = createApp(App);

/**
 * Register global components
 */
RegisterGlobalComponents(app);
app
  .use(store)
  .use(router)
  .use(apiPlugin, {
    apis: {
      main: process.env.VUE_APP_API_MAIN,
      admin: process.env.VUE_APP_API_ADMIN,
    },
  } as ApiPluginOptions)
  .use(RegisterGlobalFilters)
  .use(RegisterGlobalUtils)
  .mixin(TitleMixin)
  .use(ElementPlus)
  /**
   * Register shared components
   */
  .component("app-left-nav", LeftNavComponent)
  .component("app-top-nav", TopNavComponent)
  .component("app-main-layout", AppMainLayout)
  /**
   * Mount
   */
  .mount("#app");
